import { twMerge } from "tailwind-merge";

function Pagination({ className, children }) {
  return (
    <nav className={className}>
      <ul className="flex w-full items-center mr-0 sm:w-auto sm:mr-auto">{children}</ul>
    </nav>
  );
}

function PaginationLink({ className, active, children }) {
  return (
    <li className="">
      <button
        as="a"
        className={twMerge([
          "min-w-0 sm:min-w-[40px] shadow-none font-normal flex items-center justify-center border-transparent text-slate-800 dark:text-slate-300",
          active && "!box font-medium dark:bg-darkmode-400",
          className,
        ])}
      >
        {children}
      </button>
    </li>
  );
}

Pagination.Link = PaginationLink;

export default Pagination;
